export default "__VITE_ASSET__BJz_NEgA__"